import {
  HTTP_METHOD_GET,
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
} from '@/common/api/api.service'
import { API_BASE_URL } from '@/common/constant'
import { normalizeEventDetail } from '@/common/normalize'

/**
 * 특정 이벤트 상세 정보를 조회한다.
 * @param eventId 이벤트 고유 ID
 */
export const getEventDetail = async ({ eventId }) => {
  const response = await apiRequest(
    commonRequestInstanceToAxiosRequestInfo({
      url: `${API_BASE_URL}/events/${eventId}`,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true,
    }),
    (error) => {
      return { error: { ...error } }
    },
  )
  if (!response || response?.error) {
    return response
  }

  response.data = normalizeEventDetail(response?.data)
  return response
}
